module.exports = __webpack_public_path__ + "static/media/inicio.cf95f30b.png";